import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{

  },
  content: {
    padding: '20px'
  },

}));

export default useStyles;
